import React from "react";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonInput from "../../../components/forms/CommonInput";
import CommonInputDecimal from "../../../components/forms/CommonInputDecimal";
import {
  handleChange,
  handleChangeNameValue,
} from "../../../helpers/handleFormChanges";
import CommonButton from "../../../components/buttons/CommonButton";
import PropTypes from "prop-types";

function RecompensasCadastro({ valuesHook, salvarIndicacao, empresas }) {
  const { values, setValues } = valuesHook;

  return (
    <>
      <h4 className="card-title mb-4">Cadastrar indicação</h4>
      <div className="row">
        <div className="col-lg-4 mb-3">
          <CommonSelect
            label="Empresa"
            id="empresa"
            value={values.empresa}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={Object.values(empresas).map((empresa) => ({
              text: empresa.razao_social,
              id: empresa.uid,
            }))}
            placeholder="Selecione uma empresa"
            required
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonSelect
            label="Tipo recompensa"
            id="tipoRecompensa"
            value={values.tipoRecompensa}
            onChange={(e) => {
              setValues({
                ...values,
                tipoRecompensa: e.target.value,
                valor: 0,
              });
            }}
            data={[
              { id: 1, text: "Absoluto" },
              { id: 2, text: "Percentual" },
            ]}
            placeholder="Selecione um tipo"
            required
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInput
            label="Referência início"
            id="inicio"
            value={values.inicio}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            type="month"
            required
            max={values?.fim}
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInput
            label="Referência fim"
            id="fim"
            value={values.fim}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            type="month"
            required
            min={values?.inicio}
          />
        </div>
        <div className="col-lg-2 mb-3">
          {values?.tipoRecompensa === "2" ? (
            <CommonInputDecimal
              label="Valor"
              id="valor"
              value={values.valor}
              onChange={(value) => {
                handleChangeNameValue(
                  "valor",
                  value.floatValue,
                  values,
                  setValues
                );
              }}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue < 100;
              }}
              required
            />
          ) : (
            <CommonInputDecimal
              label="Valor"
              id="valor"
              value={values.valor}
              onChange={(value) => {
                handleChangeNameValue(
                  "valor",
                  value.floatValue,
                  values,
                  setValues
                );
              }}
              required
            />
          )}
        </div>
      </div>
      <CommonButton
        onClick={() => {
          salvarIndicacao();
        }}
        color="success"
      >
        Salvar
      </CommonButton>
    </>
  );
}

RecompensasCadastro.propTypes = {
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  salvarIndicacao: PropTypes.func.isRequired,
  empresas: PropTypes.array.isRequired,
};

export default RecompensasCadastro;
